export default "__VITE_ASSET__f2b6acf1__"